import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';


export const FormularioBusqueda = (props) => {

    const [errores] = useState({});
    const [estados] = useState([]);
    const [buscarEmpresa, setBuscarEmpresa] = useState({});
    const { funcionExito } = props;

    const buscar = () => {
        funcionExito(buscarEmpresa);
    }

    const reiniciar = () => {
        setBuscarEmpresa({});
    }

    const handleChange = e => {
        const { name, value } = e.target;
        let elValor = value;
        if (elValor && typeof elValor !== 'object')
            elValor = elValor.toUpperCase();
        setBuscarEmpresa(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: elValor
        }));
    };

    return (
        <div>
            <div className="card card-w-title">
                <div className="p-fluid p-grid">
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="search" maxLength="11" id="registroPatronal"
                                name="registroPatronal" value={buscarEmpresa.registroPatronal || ""}
                                className={errores.registroPatronal ? "p-error" : ""}
                                onChange={handleChange} style={{ width: "90%" }} />
                            <label> Registro Patronal:</label>
                            {errores.registroPatronal ? <div><Message severity="error" text={errores.registroPatronal} /> </div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="search" id="razonSocial" name="razonSocial"
                                value={buscarEmpresa.razonSocial || ""} className={errores.razonSocial ? "p-error" : ""}
                                onChange={handleChange} style={{ width: "90%" }} />
                            <label> Razón Social:</label>
                            {errores.razonSocial ? <div><Message severity="error" text={errores.razonSocial} /> </div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="search" id="rfc" name="rfc"
                                value={buscarEmpresa.rfc || ""} className={errores.rfc ? "p-error" : ""}
                                onChange={handleChange} style={{ width: "90%" }} />
                            <label> Rfc Empresa:</label>
                            {errores.rfc ? <div><Message severity="error" text={errores.rfc} /> </div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="search" id="representanteLegal"
                                name="representanteLegal" value={buscarEmpresa.representanteLegal || ""}
                                className={errores.representanteLegal ? "p-error" : ""}
                                onChange={handleChange} style={{ width: "90%" }} />
                            <label> Representante Legal:</label>
                            {errores.representanteLegal ? <div><Message severity="error" text={errores.representanteLegal} /> </div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="search" id="actividadEconomica"
                                name="actividadEconomica" value={buscarEmpresa.actividadEconomica || ""}
                                className={errores.actividadEconomica ? "p-error" : ""}
                                onChange={handleChange} style={{ width: "90%" }} />
                            <label> Actividad Economica:</label>
                            {errores.actividadEconomica ? <div><Message severity="error" text={errores.actividadEconomica} /> </div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">

                        <Dropdown id="estado" name="estado" options={estados}
                            value={buscarEmpresa.estado}
                            onChange={handleChange} autoWidth={false} style={{ width: "90%" }} />
                        {errores.estado ? <div><Message severity="error" text={errores.estado} /></div> : null}

                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button className="p-button-Primary p-button-raised" label="Limpiar" icon="pi-md-refresh" onClick={reiniciar} tooltip={"Borrar"} />
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button className="p-button-Primary p-button-raised" label="Buscar" icon="pi-md-search" onClick={buscar} tooltip={"Buscar"} />
                    </div>
                </div>
            </div>
        </div>
    );
}